import { Injectable } from '@angular/core';
import { UzytkownikDto, UzytkownikDtoQueryParams } from '@interfaces/komunikacja/komunikacja.interface';
import { IPaginatedData } from '@interfaces/response.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KomunikacjaService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/komunikacja`;

  getUzytkownicy(queryParams?: UzytkownikDtoQueryParams): Observable<IPaginatedData<UzytkownikDto>> {
    return this.http.get<IPaginatedData<UzytkownikDto>>(`${this.endpoint}/uzytkownicy`, {
      params: this.createQueryParams(queryParams),
    });
  }
}
